// ─────────────────────────────────────────────────────────────────
// Glass-i — Company Defaults change-history drawer (Stage 6CM.1).
//
// Read-only right slide-over listing company_default_events (latest first):
// CREATED / UPDATED / RESET_TO_DEFAULT / SEEDED_FROM_PROFORMA_SETTINGS.
// ─────────────────────────────────────────────────────────────────

import { Drawer, Timeline, Empty, Tag, Spin } from 'antd';

const TYPE_COLOR = {
  CREATED: 'green',
  UPDATED: 'blue',
  RESET_TO_DEFAULT: 'orange',
  SEEDED_FROM_PROFORMA_SETTINGS: 'purple'
};

function fmt(ts) {
  try { return ts ? new Date(ts).toLocaleString() : ''; }
  catch (_e) { return String(ts || ''); }
}

export default function CompanyDefaultsEventsDrawer({ open, onClose, events = [], loading = false }) {
  return (
    <Drawer
      open={open}
      placement="right"
      width={460}
      onClose={onClose}
      destroyOnClose
      title={(
        <div className="flex flex-col leading-tight">
          <span className="text-sm font-semibold text-slate-900">Change History</span>
          <span className="text-[11px] font-normal text-slate-500">
            Company Defaults events — latest first
          </span>
        </div>
      )}
    >
      <Spin spinning={loading}>
        {(!events || events.length === 0) ? (
          <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} description="No change history yet" />
        ) : (
          <Timeline
            items={events.map((e, i) => ({
              key: e.id || i,
              color: TYPE_COLOR[e.eventType] || 'gray',
              children: (
                <div>
                  <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
                    <Tag color={TYPE_COLOR[e.eventType]} style={{ margin: 0 }}>{e.eventType}</Tag>
                    <span style={{ fontSize: 11, color: '#94a3b8' }}>{fmt(e.createdAt)}</span>
                  </div>
                  {e.remarks ? (
                    <div style={{ fontSize: 12, color: '#475569', marginTop: 4 }}>{e.remarks}</div>
                  ) : null}
                </div>
              )
            }))}
          />
        )}
      </Spin>
    </Drawer>
  );
}
